<template>
  <SimpleModuleDashboard
    :module-id="Modules.ACTIVIDAD_LOG"
    :profile-id="Profiles.PERSONAL"
    :actions="dashboardActions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Helper from '@/handler/helper'
import ServicesPHP from '@/components/modules/users/php/staff/services'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({ Modules, Profiles, phpCustom: [] }),
  computed: {
    dashboardActions() {
      const actions = [{ id: 'viewer', reference: 'viewer', route: 'ActivityLogStaffViewer', tone: 'primary' }]
      if(Helper.showAccessPHPCustom()) {
        this.phpCustom.forEach(item => actions.push({
          id: 'php-custom-' + item.id, title: item.name, description: item.observations || 'Herramienta personalizada del módulo',
          icon: 'fa fa-code', tone: 'warning', dynamic: true, route: 'ViewStaffViewPHPCustom', params: { id: item.id },
        }))
      }
      return actions
    },
  },
  created() {
    ServicesPHP.obtenerPHPByModule(Modules.ACTIVIDAD_LOG).then(response => { this.phpCustom = response.data })
  },
}
</script>
